const homeContentCarbonFootPrintEndpoints = {
  base: "/v1/cms/home-content/carbon-foot-print",
  byId: (id) => `/v1/cms/home-content/carbon-foot-print/${id}`,
};

export default homeContentCarbonFootPrintEndpoints;
